<template>
  <v-card class="com-pc-card tm-list">
    <div class="com-pc-card-header tm-header">
      <span class="com-pc-card-title">基準値超過観測所一覧</span>
      <!-- 凡例 -->
      <v-tooltip
        bottom
        class="rw-tab-guide-tip"
        v-if="tabIndex !== 1"
        max-width="450"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-1"
            >help_outline</v-icon
          >
        </template>
        <span v-if="tabIndex === 0">
          <span>
            {{ config.messageConfig.legendMsg.tmStg.tmStgMsg1 }}
            <br />
            {{ config.messageConfig.legendMsg.tmStg.tmStgMsg2 }}
            <br />
          </span>
          <span class="text-flood-occurrence rw-status-legend mb-1">
            {{ config.messageConfig.legendMsg.tmStg.occurrence }}
          </span>
          <br />
          <span class="text-flood-danger rw-status-legend mb-1">
            {{ config.messageConfig.legendMsg.tmStg.danger }}</span
          >
          <br />
          <span class="text-flood-refuge rw-status-legend mb-1">
            {{ config.messageConfig.legendMsg.tmStg.refuge }}
          </span>
          <br />
          <span class="text-flood-warn rw-status-legend mb-1">
            {{ config.messageConfig.legendMsg.tmStg.warn }}
          </span>
        </span>
        <span v-if="tabIndex === 2">
          <span>
            {{ config.messageConfig.legendMsg.swStg.swStgMsg1 }}
            <br />
            {{ config.messageConfig.legendMsg.swStg.swStgMsg2 }}
            <br />
          </span>
          <v-row no-gutters class="pt-1 pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-item">
                  {{ config.messageConfig.legendMsg.swStg.flood1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-flood legend-swstg-detail">
                  {{ config.messageConfig.legendMsg.swStg.flood2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-item">
                  {{ config.messageConfig.legendMsg.swStg.danger1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-danger legend-swstg-detail">
                  {{ config.messageConfig.legendMsg.swStg.danger2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-1">
            <v-col>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-item">
                  {{ config.messageConfig.legendMsg.swStg.start1 }}
                </div>
              </v-row>
              <v-row no-gutters>
                <div class="text-swstg-start legend-swstg-detail">
                  {{ config.messageConfig.legendMsg.swStg.start2 }}
                </div>
              </v-row>
            </v-col>
          </v-row>
        </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <span class="rw-time pr-4">{{ appTime }}</span>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!pcPanelMode"
            icon
            dark
            small
            class="mr-4"
            @click="renew"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.refresh }}</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="pcPanelMode"
            icon
            dark
            small
            class="mr-4"
            @click="returnWindowMode"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.panelModeOff }}</span>
      </v-tooltip>
    </div>
    <div v-if="!pcPanelMode" class="tm-area-select pl-4">
      地方選択
      <div class="tm-comb pl-4">
        <v-select dense :items="area.item" v-model="areaIdx"></v-select>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="tm-tab">
      <div class="tab">
        <!-- 表示切替タブ -->
        <v-btn class="com-btn mr-2" :class="tmBtnStates(0)" @click="clickTab(0)"
          >水位観測</v-btn
        >
        <v-btn class="com-btn" :class="tmBtnStates(1)" @click="clickTab(1)"
          >雨量</v-btn
        >
        <v-btn class="com-btn ml-2" :class="tmBtnStates(2)" @click="clickTab(2)" style="white-space: pre-wrap"
          >{{this.$store.state.app.config.replaceNameConfig.swstgLF}}</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <div v-if="tabIndex === 0" class="tm-tab-label pr-4">
        ※抽出条件：氾濫注意水位以上
      </div>
      <div v-if="tabIndex === 1" class="tm-tab-label pr-4">
        ※抽出条件：60分30mm以上
      </div>
      <div v-if="tabIndex === 2" class="tm-tab-label pr-4">
        {{ config.overViewConfig.swstg.dispMessage }}
      </div>
    </div>

    <div class="tm-box">
      <div class="tm-box-ov">
        <!-- 水位観測 -->
        <div class="ma-0 pa-0 tm-box-list" v-if="tabIndex === 0">
          <v-col
            class="tm-no-regist"
            v-if="
              pcPanelMode &&
                (!tmOverDatas.tmStg || tmOverDatas.tmStg.length == 0)
            "
            >{{ this.$store.state.app.config.messageConfig.ovNoRegist }}</v-col
          >
          <v-col
            class="tm-no-regist"
            v-if="
              !pcPanelMode &&
                (!tmOverDatas.tmStg || tmOverDatas.tmStg.length == 0)
            "
            >{{
              this.$store.state.app.config.messageConfig.ovNoRegistSelect
            }}</v-col
          >
          <v-list
            class="pa-0"
            light
            v-for="(tmStg, tmStgIdx) in tmOverDatas.tmStg"
            :key="'tmStgIdx' + tmStgIdx"
          >
            <v-list-item
              @click="clickOverList(tmStg.ofcCd, tmStg.itmkndCd, tmStg.obsCd)"
              class="tm-list-item-stg"
            >
              <!-- アイコン -->
              <v-list-item-action class="overview-icon">
                <img
                  v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg < 0"
                  src="/kawabou/img/obs_icons/obs_water_caution_down.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg === 0"
                  src="/kawabou/img/obs_icons/obs_water_caution.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 30 && tmStg.stgChg > 0"
                  src="/kawabou/img/obs_icons/obs_water_caution_up.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg < 0"
                  src="/kawabou/img/obs_icons/obs_water_refuge_down.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg === 0"
                  src="/kawabou/img/obs_icons/obs_water_refuge.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 60 && tmStg.stgChg > 0"
                  src="/kawabou/img/obs_icons/obs_water_refuge_up.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg < 0"
                  src="/kawabou/img/obs_icons/obs_water_danger_down.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg === 0"
                  src="/kawabou/img/obs_icons/obs_water_danger.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 80 && tmStg.stgChg > 0"
                  src="/kawabou/img/obs_icons/obs_water_danger_up.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg < 0"
                  src="/kawabou/img/obs_icons/obs_water_flood_down.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg === 0"
                  src="/kawabou/img/obs_icons/obs_water_flood.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="tmStg.stgOvlvl === 90 && tmStg.stgChg > 0"
                  src="/kawabou/img/obs_icons/obs_water_flood_up.svg"
                  class="tm-icon-telemeter"
                />
              </v-list-item-action>
              <v-list-item-content>
                <!-- 基準観測所有り観測所名 -->
                <v-list-item-title>
                  <div
                    v-if="
                      tmStg.fldfrFlg === 1 ||
                        tmStg.evstgFlg === 1 ||
                        (isFldCtl && tmStg.fldctlFlg === 1)
                    "
                    class="tm-label"
                  >
                    {{ tmStg.obsNm }}{{ referenceObs }}
                  </div>
                </v-list-item-title>
                <!-- 基準観測所なし観測所名 -->
                <v-list-item-title>
                  <div
                    v-if="
                      tmStg.fldfrFlg === 0 &&
                        tmStg.evstgFlg === 0 &&
                        (!isFldCtl || tmStg.fldctlFlg === 0)
                    "
                    class="tm-label"
                  >
                    {{ tmStg.obsNm }}
                  </div>
                </v-list-item-title>
                <!-- 河川名・水系名 -->
                <v-list-item-subtitle
                  >{{ tmStg.rvrNm }}({{
                    tmStg.rsysNm
                  }}水系)</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <!-- 超過表示 -->
                <div class="tm-stage-level">
                  <object
                    v-if="tmStg.chisei != 'center'"
                    :id="'tm_stage_' + tmStgIdx"
                    type="image/svg+xml"
                    :data="stageLevelUrl"
                  ></object>
                  <object
                    v-if="tmStg.chisei == 'center'"
                    :id="'tm_stage_' + tmStgIdx"
                    type="image/svg+xml"
                    :data="stageLevelCenterUrl"
                  ></object>
                </div>
              </v-list-item-action>
              <v-list-item-content class="tm-content-stage pl-4">
                <!-- 観測日時 -->
                <v-list-item-title class="pl-4">{{
                  tmStg.obsTime
                }}</v-list-item-title>

                <v-list-item-subtitle class="tm-subitem-stage pr-8">
                  <!--河床から -->
                  <span
                    class="tm-span-stg"
                    v-if="
                      stgMode === '0' || (stgMode === '1' && tmStg.dspFlg === 2)
                    "
                    >{{ stgMsg.normalStg }}{{ formatStg(tmStg.stg) }}m</span
                  >
                  <!--堤防高から -->
                  <span
                    class="tm-span-stg"
                    v-if="stgMode === '1' && tmStg.dspFlg === 1"
                    >{{ stgMsg.topendStg }}{{ formatStg(tmStg.stgHght) }}m</span
                  >
                  <!-- 上昇・下降の矢印 -->
                  <span class="tm-span-arrow">
                    <v-icon v-if="tmStg.stgChg < 0" class="icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon v-if="tmStg.stgChg === 0" class="icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon v-if="tmStg.stgChg > 0" class="icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                  </span>
                  <!-- 品管フラグ -->
                  <span class="tm-span-qmflg">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="tmStg.stgQmflg && tmStg.stgQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-content>
                <!-- 所在地 -->
                <v-list-item-title>
                  <div class="tm-label">{{ tmStg.obsAdr }}</div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <!-- 基準値 -->
                <v-tooltip
                  left
                  v-if="
                    (stgMode === '0' ||
                      (stgMode === '1' && tmStg.dspFlg === 2)) &&
                      (tmStg.fldStg ||
                        tmStg.dngStg ||
                        tmStg.spclWarnStg ||
                        tmStg.warnStg ||
                        tmStg.rsrvStg)
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      v-on="on"
                      >基準値</v-btn
                    >
                  </template>
                  <span v-if="tmStg.fldStg">
                    氾濫開始水位 ：{{ tmStg.fldStg }}m
                    <br />
                  </span>
                  <span v-if="tmStg.dngStg">
                    氾濫危険水位 ：{{ tmStg.dngStg }}m
                    <br />
                  </span>
                  <span v-if="tmStg.spclWarnStg">
                    避難判断水位 ：{{ tmStg.spclWarnStg }}m
                    <br />
                  </span>
                  <span v-if="tmStg.warnStg">
                    氾濫注意水位 ：{{ tmStg.warnStg }}m
                    <br />
                  </span>
                  <span v-if="tmStg.rsrvStg && isFldCtl"
                    >水防団待機水位：{{ tmStg.rsrvStg }}m</span
                  >
                </v-tooltip>
                <v-tooltip
                  left
                  v-else-if="
                    stgMode === '1' &&
                      tmStg.dspFlg === 1 &&
                      (tmStg.fldStgHght ||
                        tmStg.dngStgHght ||
                        tmStg.spclWarnStgHght ||
                        tmStg.warnStgHght ||
                        tmStg.rsrvStgHght)
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      v-on="on"
                      >基準値</v-btn
                    >
                  </template>
                  <span v-if="tmStg.fldStgHght != null">
                    氾濫開始水位 ：{{ tmStg.fldStgHght }}m
                    <br />
                  </span>
                  <span v-if="tmStg.dngStgHght">
                    氾濫危険水位 ：{{ tmStg.dngStgHght }}m
                    <br />
                  </span>
                  <span v-if="tmStg.spclWarnStgHght">
                    避難判断水位 ：{{ tmStg.spclWarnStgHght }}m
                    <br />
                  </span>
                  <span v-if="tmStg.warnStgHght">
                    氾濫注意水位 ：{{ tmStg.warnStgHght }}m
                    <br />
                  </span>
                  <span v-if="tmStg.rsrvStgHght && isFldCtl"
                    >水防団待機水位：{{ tmStg.rsrvStgHght }}m</span
                  >
                </v-tooltip>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      v-on="on"
                      >基準値</v-btn
                    >
                  </template>
                  <span>
                    基準値は設定されていません
                    <br />
                  </span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
        <!-- 雨量 -->
        <div class="ma-0 pa-0 tm-box-list" v-if="tabIndex === 1">
          <v-col
            class="tm-no-regist"
            v-if="
              pcPanelMode && (!tmOverDatas.tmRn || tmOverDatas.tmRn.length == 0)
            "
            >{{ this.$store.state.app.config.messageConfig.ovNoRegist }}</v-col
          >
          <v-col
            class="tm-no-regist"
            v-if="
              !pcPanelMode &&
                (!tmOverDatas.tmRn || tmOverDatas.tmRn.length == 0)
            "
            >{{
              this.$store.state.app.config.messageConfig.ovNoRegistSelect
            }}</v-col
          >
          <v-list
            class="pa-0"
            light
            v-for="(tmRn, tmRnIdx) in tmOverDatas.tmRn"
            :key="'tmRnIdx' + tmRnIdx"
          >
            <v-list-item
              @click="clickOverList(tmRn.ofcCd, tmRn.itmkndCd, tmRn.obsCd)"
              class="tm-list-item"
            >
              <!-- アイコン -->
              <v-list-item-action class="overview-icon">
                <img
                  src="/kawabou/img/obs_icons/obs_rain_normal.svg"
                  class="tm-icon-telemeter"
                />
              </v-list-item-action>
              <v-list-item-content>
                <!-- 観測所名 -->
                <v-list-item-title>{{ tmRn.obsNm }}</v-list-item-title>
                <!-- 河川名・水系名 -->
                <v-list-item-subtitle
                  >{{ tmRn.rvrNm }}({{ tmRn.rsysNm }}水系)</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-content>
                <!-- 観測日時 -->
                <v-list-item-title>{{ tmRn.obsTime }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="tm-content-stage pr-6">
                <v-list-item-title class="tm-subitem-stage">
                  <!-- 60分雨量 -->
                  <span class="tm-span-stg pr-4">{{ tmRn.rn60m }}mm</span>
                  <!-- 品管フラグ -->
                  <span class="tm-span-qmflg">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="tmRn.rn60mQmflg && tmRn.rn60mQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex:1.5">
                <!-- 所在地 -->
                <v-list-item-title>
                  <div class="tm-label">{{ tmRn.obsAdr }}</div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
        <!-- 水位計 -->
        <div class="ma-0 pa-0 tm-box-list" v-if="tabIndex === 2">
          <v-col
            class="tm-no-regist"
            v-if="
              pcPanelMode &&
                (!tmOverDatas.swStg || tmOverDatas.swStg.length == 0)
            "
            >{{ this.$store.state.app.config.messageConfig.ovNoRegist }}</v-col
          >
          <v-col
            class="tm-no-regist"
            v-if="
              !pcPanelMode &&
                (!tmOverDatas.swStg || tmOverDatas.swStg.length == 0)
            "
            >{{
              this.$store.state.app.config.messageConfig.ovNoRegistSelect
            }}</v-col
          >
          <v-list
            class="pa-0"
            light
            v-for="(swStg, swStgIdx) in tmOverDatas.swStg"
            :key="'swStgIdx' + swStgIdx"
          >
            <v-list-item
              @click="clickOverList(swStg.swofcCd, 300, swStg.swobsCd)"
              class="tm-list-item"
            >
              <!-- アイコン -->
              <v-list-item-action class="overview-icon">
                <img
                  v-if="swStg.swstgOvlvl === 30"
                  src="/kawabou/img/obs_icons/obs_swstg_start.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="
                    swStg.swstgOvlvl === config.overViewConfig.swstg.dispOvlvl
                  "
                  src="/kawabou/img/obs_icons/obs_swstg_danger.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="swStg.swstgOvlvl === 90"
                  src="/kawabou/img/obs_icons/obs_swstg_flood.svg"
                  class="tm-icon-telemeter"
                />
              </v-list-item-action>
              <v-list-item-content>
                <!-- 観測所名 -->
                <v-list-item-title>
                  <div class="tm-label">{{ swStg.swobsNm }}</div>
                </v-list-item-title>
                <!-- 河川名・水系名 -->
                <v-list-item-subtitle
                  >{{ swStg.swrvrNm }}({{
                    swStg.swrsysNm
                  }}水系)</v-list-item-subtitle
                >
              </v-list-item-content>
              <!-- 超過アイコン -->
              <v-list-icon>
                <div
                  v-if="swStg.swstgOvlvl === 30"
                  class="text-swstg-start icon-swstg-level"
                >
                  水位計測中
                </div>
                <div
                  v-if="
                    swStg.swstgOvlvl === config.overViewConfig.swstg.dispOvlvl
                  "
                  class="text-swstg-danger icon-swstg-level"
                >
                  危険水位超過
                </div>
                <div
                  v-if="swStg.swstgOvlvl === 90"
                  class="text-swstg-flood icon-swstg-level"
                >
                  氾濫開始水位超過
                </div>
              </v-list-icon>
              <v-list-item-content class="tm-content-stage pl-4">
                <!-- 観測日時 -->
                <v-list-item-title class="pl-4">{{
                  swStg.obsTime
                }}</v-list-item-title>

                <v-list-item-subtitle class="tm-subitem-stage pr-8">
                  <!--堤防高から -->
                  <span class="tm-span-stg"
                    >{{ stgMsg.topendStg }}{{ formatStg(swStg.stgHght) }}m</span
                  >
                  <!-- 品管フラグ -->
                  <span class="tm-span-qmflg">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="swStg.stgQmflg && swStg.stgQmflg != '0'"
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-content>
                <!-- 所在地 -->
                <v-list-item-title>
                  <div class="tm-label">{{ swStg.addr }}</div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <!-- 基準値 -->
                <v-tooltip
                  left
                  v-if="
                    swStg.fldStgHght || swStg.dngStgHght || swStg.strtStgHght
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      v-on="on"
                      >基準値</v-btn
                    >
                  </template>
                  <span v-if="swStg.fldStgHght != null">
                    氾濫開始水位 ：{{ swStg.fldStgHght }}m
                    <br />
                  </span>
                  <span v-if="swStg.dngStgHght">
                    危険水位 ：{{ swStg.dngStgHght }}m
                    <br />
                  </span>
                  <span v-if="swStg.strtStgHght">
                    観測開始 ：{{ swStg.strtStgHght }}m
                    <br />
                  </span>
                </v-tooltip>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      small
                      color="success"
                      class="tm-disp-button"
                      v-on="on"
                      >基準値</v-btn
                    >
                  </template>
                  <span>
                    基準値は設定されていません
                    <br />
                  </span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util.js";
import PageLog from "./../../../lib/pageLog.js";
import color from "./../../../scss/color.scss";
export default {
  name: "tm-over-list",
  mixins: [mixin],
  data() {
    return {
      tabIndex: 0,
      areaIdx: 0,
      area: {
        item: [
          "全国",
          "北海道",
          "東北",
          "関東",
          "北陸",
          "中部",
          "近畿",
          "中国",
          "四国",
          "九州",
          "沖縄",
        ],
        value: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90],
      },
      /** 文字列リソース */
      text: {
        abnormal: "異常のおそれあり",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[TmOverList] mounted()");

    // パラメータによって初期表示するタブを変更
    let knd = this.$route.query["knd"];
    if (knd === "stg") {
      this.tabIndex = 0;
    } else if (knd === "rn") {
      this.tabIndex = 1;
    } else if (knd === "swstg") {
      this.tabIndex = 2;
    }

    // 拡大表示以外の場合は初期処理でデータを取得する
    if (!this.pcPanelMode) {
      this.$log.debug("[TmOverList] mounted() !this.pcPanelMode");
    } else {
      this.getTmOverDatas();
      // 超過度バーの描画
      setTimeout(() => {
        this.drawStageLevel();
      }, 1500);
    }
  },
  computed: {
    /**
     * 表示時刻
     */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    /**
     * 表示範囲のテレメータ超過情報
     */
    tmOverDatas: {
      get() {
        return this.$store.state.Telemeter.tmOverDatas;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRound,
          towns: this.$store.state.map.towns,
          prefs: this.$store.state.map.prefs,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    /**
     * 超過度画像URL
     */
    stageLevelUrl: {
      get() {
        let url = "/kawabou/img/stg_ovdeg.svg";
        return url;
      },
    },
    /**
     * 超過度画像URL（中部）
     */
    stageLevelCenterUrl: {
      get() {
        let url = "/kawabou/img/stg_ovdeg_center.svg";
        return url;
      },
    },
    /**
     * 選択地方インデックス
     */
    selectedArea: {
      get() {
        return this.areaIdx;
      },
    },
    /**
     * 選択タブインデックス
     */
    selectedTab: {
      get() {
        return this.tabIndex;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /**
     * 基準観測所
     */
    referenceObs: {
      get() {
        return this.$store.state.app.config.messageConfig.obsList.referenceObs;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
  },
  methods: {
    /**
     * 更新クリックイベント
     */
    renew() {
      this.$log.debug("[TmOverList] renew()");
      this.$store.commit("app/renewTime");
    },
    /**
     * ウィンドウモード戻るクリックイベント
     */
    returnWindowMode() {
      this.$log.debug("[TmOverList] returnWindow()");
      this.$store.commit("app/setPcPanelMode", false);
      this.$store.commit("app/setPcPanelModeContent", "");
      this.$store.commit("map/mapRedraw");

      let knd = this.$route.query["knd"];
      if (knd === "stg") {
        this.tabIndex = 0;
      } else if (knd === "rn") {
        this.tabIndex = 1;
      } else if (knd === "swstg") {
        this.tabIndex = 2;
      }
      let setQuery = Object.assign({}, this.$route.query);
      delete setQuery["ext"];
      delete setQuery["ovmd"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /**
     * タブクリック
     */
    clickTab(index) {
      this.$log.debug("[TmOverList] clickTab(" + index + ")");
      this.tabIndex = index;
      let areaCd = this.$route.query["area"];
      let knd = "";
      let pLogNm = "";
      if (index === 0) {
        knd = "stg";
        pLogNm = "over_stg";
      } else if (index === 1) {
        knd = "rn";
        pLogNm = "over_rain";
      } else if (index === 2) {
        knd = "swstg";
        pLogNm = "over_sw";
      }
      // アクセスログ出力
      PageLog.log({
        page_log: pLogNm,
        lat: "-",
        lon: "-",
        zm: "-",
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      // 拡大表示
      if (this.pcPanelMode) {
        this.$log.debug("[TmOverList] clickTab(paPanel)");
        let setQuery = Object.assign({}, this.$route.query);
        setQuery.knd = knd;
        this.$router.replace({
          path: this.$route.path,
          query: setQuery,
        });
        // 別ウィンドウ画面の地方コンボを選択した際のタブ切替
      } else if (!this.pcPanelMode && areaCd) {
        this.$log.debug("[TmOverList] clickTab(no paPanel area" + areaCd + ")");
        let setQuery = Object.assign({}, this.$route.query);
        setQuery.knd = knd;
        setQuery.area = areaCd;
        this.$router.replace({
          path: this.$route.path,
          query: setQuery,
        });
        // 別ウィンドウ画面
      } else {
        this.$log.debug("[TmOverList] clickTab(no paPanel)");
        let setQuery = Object.assign({}, this.$route.query);
        setQuery.knd = knd;
        this.$router.replace({
          path: this.$route.path,
          query: setQuery,
        });
      }
    },
    /**
     * テレメータ超過一覧情報を取得
     */
    getTmOverDatas() {
      this.$log.debug("[TmOverList] getTmOverDatas()");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "over_stg";
      if (this.tabIndex == 1) pLogNm = "over_rain";
      if (this.tabIndex == 2) pLogNm = "over_sw";
      PageLog.log({
        page_log: pLogNm,
        lat: "-",
        lon: "-",
        zm: "-",
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      if (
        typeof this.$route.query["minlat"] !== "undefined" &&
        typeof this.$route.query["minlon"] !== "undefined" &&
        typeof this.$route.query["maxlat"] !== "undefined" &&
        typeof this.$route.query["maxlon"] !== "undefined"
      ) {
        this.$log.debug(
          "[TmOverList] getTmOverDatas 緯度・経度からAPI呼び出し"
        );
        // 緯度・経度をパラメータに遷移した場合
        setTimeout(() => {
          this.$store.dispatch("Telemeter/getTmOvDatasByLatLon", {
            zm: this.$route.query["zm"],
            appTime: this.reqParam.appTime,
            minlat: this.$route.query["minlat"],
            minlon: this.$route.query["minlon"],
            maxlat: this.$route.query["maxlat"],
            maxlon: this.$route.query["maxlon"],
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        }, 500);
      } else if (typeof this.$route.query["area"] !== "undefined") {
        this.$log.debug(
          "[TmOverList] getTmOverDatas 都道府県リストから情報取得"
        );
        let list = this.getPrefs(this.$route.query["area"]);
        var prefs = [];
        // id:コード形式に変換
        for (var item of list) {
          prefs.push({ id: item });
        }
        setTimeout(() => {
          this.$store.dispatch("Telemeter/getTmOvDatasPref", {
            appTime: this.reqParam.appTime,
            prefs: prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
            isCurrent: this.$store.state.app.isCurrent,
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        }, 500);
        // }
      } else {
        // パラメータがどちらもない場合は、地図表示域の情報を表示
        setTimeout(() => {
          if (this.$store.state.map.prefTownType === "pref") {
            this.$store.dispatch("Telemeter/getTmOvDatasPref", {
              appTime: this.reqParam.appTime,
              prefs: this.reqParam.prefs,
              townsAcqTime: this.reqParam.townsAcqTime,
              isCurrent: this.$store.state.app.isCurrent,
              dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
            });
          } else {
            this.$store.dispatch("Telemeter/getTmOvDatas", {
              appTime: this.reqParam.appTime,
              towns: this.reqParam.towns,
              townsAcqTime: this.reqParam.townsAcqTime,
              isCurrent: this.$store.state.app.isCurrent,
              dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
            });
          }
        }, 500);
      }
    },
    /**
     * テレメータ超過一覧情報を取得
     * @param areaCode 地方コード
     */
    getTmOverDatasByArea(areaCode) {
      this.$log.debug("[TmOverList] getTmOverDatasByArea(" + areaCode + ")");
      // アクセスログ出力
      // ログ名称設定
      let pLogNm = "";
      if (this.tabIndex == 0) pLogNm = "over_stg";
      if (this.tabIndex == 1) pLogNm = "over_rain";
      if (this.tabIndex == 2) pLogNm = "over_sw";
      PageLog.log({
        page_log: pLogNm,
        lat: "-",
        lon: "-",
        zm: "-",
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      var prefs = [];
      let list = this.getPrefs(areaCode);
      // id:コード形式に変換
      for (var item of list) {
        prefs.push({ id: item });
      }
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getTmOvDatasPref", {
          appTime: this.reqParam.appTime,
          prefs: prefs,
          townsAcqTime: this.reqParam.townsAcqTime,
          isCurrent: this.$store.state.app.isCurrent,
          dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
        });
      }, 500);
      // }
    },
    /**
     * 超過度描画
     */
    drawStageLevel() {
      this.$log.debug("[TmOverList] drawStageLevel()");
      for (var idx = 0; idx < this.tmOverDatas.tmStg.length; idx++) {
        const elmE = document.getElementById("tm_stage_" + idx);
        const elm = elmE.contentDocument;
        let info = this.tmOverDatas.tmStg[idx];
        const stgBar = elm.getElementById("stg-bar");
        stgBar.style.setProperty("width", info.stgOvdeg * 120);
        const labelBox = elm.getElementById("label-box");
        const labelText = elm.getElementById("label-text");
        // 氾濫開始水位超過用
        const labelBoxStart = elm.getElementById("label-box-start");
        const labelTextStart = elm.getElementById("label-text-start");
        switch (info.stgOvlvl) {
          case 30:
            this.$log.debug(
              "[TmOverList] drawStageLevel case:30 氾濫注意水位超過"
            );
            // 氾濫注意水位超過
            labelBox.style.setProperty("fill", color.stageWarning);
            labelBox.style.setProperty("stroke", "blue");
            labelText.innerHTML = "氾濫注意水位超過 Lvl.2水位";
            labelText.style.setProperty("fill", color.stageWarningText);
            labelText.style.setProperty("stroke", color.stageWarningText);
            break;
          case 60:
            this.$log.debug(
              "[TmOverList] drawStageLevel case:60 避難判断水位超過"
            );
            // 避難判断水位超過
            labelBox.style.setProperty("fill", color.stageRefuge);
            labelBox.style.setProperty("stroke", "blue");
            labelText.innerHTML = "避難判断水位超過 Lvl.3水位";
            labelText.style.setProperty("fill", color.stageRefugeText);
            labelText.style.setProperty("stroke", color.stageRefugeText);
            break;
          case 80:
            this.$log.debug(
              "[TmOverList] drawStageLevel case:80 氾濫危険水位超過"
            );
            // 氾濫危険水位超過
            labelBox.style.setProperty("fill", color.stageDanger);
            labelBox.style.setProperty("stroke", "blue");
            labelText.innerHTML = "氾濫危険水位超過 Lvl.4水位";
            labelText.style.setProperty("fill", color.stageDangerText);
            labelText.style.setProperty("stroke", color.stageDangerText);
            break;
          case 90:
            this.$log.debug(
              "[TmOverList] drawStageLevel case:90 氾濫開始水位超過"
            );
            // 氾濫開始水位超過
            labelBoxStart.style.setProperty("fill", color.stageOver);
            labelBoxStart.style.setProperty("stroke", "blue");
            labelTextStart.innerHTML = "氾濫開始水位超過";
            labelTextStart.style.setProperty("fill", color.stageOverText);
            labelTextStart.style.setProperty("stroke", color.stageOverText);
            break;
        }
      }
    },
    /**
     * 地方コードから都道府県リストを取得
     */
    getPrefs(areaCode) {
      this.$log.debug("[TmOverList] getPrefs(" + areaCode + ")");
      var prefs = [];
      switch (Number(areaCode)) {
        case 80:
          prefs = [
            "102",
            "103",
            "104",
            "105",
            "201",
            "301",
            "401",
            "501",
            "601",
            "701",
            "801",
            "901",
            "1001",
            "1101",
            "1201",
            "1301",
            "1401",
            "1901",
            "1501",
            "1601",
            "1701",
            "2001",
            "2101",
            "2201",
            "2301",
            "2401",
            "1801",
            "2501",
            "2601",
            "2701",
            "2801",
            "2901",
            "3001",
            "3101",
            "3201",
            "3301",
            "3401",
            "3501",
            "3601",
            "3701",
            "3801",
            "3901",
            "4001",
            "4101",
            "4201",
            "4301",
            "4401",
            "4501",
            "4601",
            "4701",
          ];
          break;
        case 81:
          prefs = ["102", "103", "104", "105"];
          break;
        case 82:
          prefs = ["201", "301", "401", "501", "601", "701"];
          break;
        case 83:
          prefs = [
            "801",
            "901",
            "1001",
            "1101",
            "1201",
            "1301",
            "1401",
            "1901",
          ];
          break;
        case 84:
          prefs = ["1501", "1601", "1701", "2001"];
          break;
        case 85:
          prefs = ["2101", "2201", "2301", "2401"];
          break;
        case 86:
          prefs = ["1801", "2501", "2601", "2701", "2801", "2901", "3001"];
          break;
        case 87:
          prefs = ["3101", "3201", "3301", "3401", "3501"];
          break;
        case 88:
          prefs = ["3601", "3701", "3801", "3901"];
          break;
        case 89:
          prefs = ["4001", "4101", "4201", "4301", "4401", "4501", "4601"];
          break;
        case 90:
          prefs = ["4701"];
          break;
      }
      return prefs;
    },
    /**
     * 超過一覧のリストクリック
     */
    clickOverList(ofcCd, itmkndCd, obsCd) {
      // ofcCd, itmkndCd, obsCd
      this.$log.debug(
        "[TmOverList] clickOverList(" +
          ofcCd +
          ", " +
          itmkndCd +
          ", " +
          obsCd +
          ")"
      );
      if (this.pcPanelMode) {
        // PCパネル拡大表示モードの場合は、モードをfalseに設定し個別観測所画面へ遷移
        // this.$store.commit("app/setPcPanelMode", false);
        // 水位計の場合
        if (itmkndCd == 300) {
          // 選択中テレメータ情報を設定
          this.$store.commit("Swin/setSelectedSwParam", {
            swofcCd: Number(ofcCd),
            itmkndCd: Number(itmkndCd),
            swobsCd: Number(obsCd),
          });
          // 画面遷移
          this.routerPushTmSw("/pc/tm");
        } else {
          // 選択中テレメータ情報を設定
          this.$store.commit("Telemeter/setSelectedTmParam", {
            ofcCd: Number(ofcCd),
            itmkndCd: Number(itmkndCd),
            obsCd: Number(obsCd),
          });
          // 画面遷移
          this.routerPushTm("/pc/tm");
        }
      } else {
        // 全体表示時には別ウィンドウで個別観測所詳細画面を表示
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            ofcCd: ofcCd,
            itmkndCd: itmkndCd,
            obsCd: obsCd,
            isCurrent: true,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_blank", "noreferrer,noopener");
      }
    },
    /**
     * 水位を小数第2位に変換
     */
    formatStg(stg) {
      this.$log.debug("[TmOverList] formatStg(" + stg + ")");
      return Util.formatFloat(stg, 2);
    },
    /**
     * 基準値超過一覧種別ボタン点滅
     */
    tmBtnStates(idx) {
      this.$log.debug("[TmOverList] tmBtnStates(" + idx + ")");
      // 選択中の基準値超過一覧
      if (idx === this.tabIndex) {
        return "com-btn-on";
        // 選択していない基準値超過一覧で超過中の場合に点滅
      } else if (
        idx === 0 &&
        this.tmOverDatas.tmStg &&
        this.tmOverDatas.tmStg.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 1 &&
        this.tmOverDatas.tmRn &&
        this.tmOverDatas.tmRn.length > 0
      ) {
        return "com-btn-flash";
      } else if (
        idx === 2 &&
        this.tmOverDatas.swStg &&
        this.tmOverDatas.swStg.length > 0
      ) {
        return "com-btn-flash";
      }
    },
  },
  watch: {
    /**
     * テレメータ超過一覧情報変更時
     */
    tmOverDatas() {
      this.$log.debug("[TmOverList] watch(tmOverDatas)");
      setTimeout(() => {
        this.drawStageLevel();
      }, 1500);
    },
    /**
     * 地方コンボの変更時
     */
    selectedArea() {
      this.$log.debug("[TmOverList] watch(selectedArea)");
      let code = this.area.value[this.area.item.indexOf(this.areaIdx)];
      let knd = "";
      if (this.tabIndex === 0) {
        knd = "stg";
      } else if (this.tabIndex === 1) {
        knd = "rn";
      } else if (this.tabIndex === 2) {
        knd = "swstg";
      }
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.area = code;
      setQuery.knd = knd;
      // 不要なパラメータ削除
      delete setQuery["zm"];
      delete setQuery["minlat"];
      delete setQuery["minlon"];
      delete setQuery["maxlat"];
      delete setQuery["maxlon"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
      this.getTmOverDatasByArea(code);
    },
    /**
     * タブ変更時
     */
    selectedTab() {
      this.$log.debug("[TmOverList] watch(selectedTab)");
      // 水位観測に変更時に、超過度を再描画
      if (this.tabIndex === 0) {
        setTimeout(() => {
          this.drawStageLevel();
        }, 1500);
      }
    },
    /**
     *  観測日時(ファイル取得用)変更時
     */
    reqParam() {
      this.$log.debug("[TmOverList] watch(reqParam)");
      this.getTmOverDatas();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../scss/kwb.scss";
.tm-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tm-list-item-stg {
    max-height: 104px;
  }

  .tm-list-item {
    max-height: 68px;
  }
  .tm-header {
    display: flex;
    .rw-time {
      color: white;
    }
  }

  .tm-area-select {
    display: flex;
    flex-direction: row;
    height: 50px;
    align-items: center;

    .tm-comb {
      width: 200px;
    }
  }

  .tm-tab {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tab {
      display: flex;
      flex-direction: row;
      padding: 8px;
    }
    .tm-tab-label {
      width: 320px;
    }
  }

  .tm-box {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
    .tm-box-ov {
      position: relative;
      flex: 1;
      height: 100%;
      width: 100%;
      .tm-box-list {
        position: absolute;
        flex: 1;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        .tm-no-regist {
          font-size: 1rem;
        }
        .tm-icon-telemeter {
          width: 26px;
        }

        .tm-content-stage {
          flex: 1;
          .tm-subitem-stage {
            display: flex;

            .tm-span-stg {
              flex: 1;
              text-align: right;
              font-size: 1.2rem;
            }
            .tm-span-arrow {
              width: 22px;
              .icon-arrow-up {
                font-size: 22px;
                color: $color-arrow-up;
              }
              .icon-arrow-down {
                font-size: 22px;
                color: $color-arrow-down;
              }
            }
            .tm-span-qmflg {
              width: 22px;
              .icon-qmflg {
                font-size: 22px;
                color: $color-qmflg;
              }
            }
          }
        }
      }
    }
  }
  .tm-stage-level {
    width: 240px;
    height: 80px;
  }
}
.icon-swstg-level {
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  width: 130px;
  display: inline-block;
  padding: 2px 4px 4px 2px;
  border-radius: 6px;
}
.tm-label {
  white-space: normal;
}
.rw-tab-guide-tip {
  z-index: 3510;
}
.rw-status-legend {
  font-size: 10pt;
  font-weight: bold;
  display: inline-block;
  padding: 2px 4px 4px 2px;
  border-radius: 6px;
}

.icon-swstg-legend {
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  display: inline-block;
  padding: 2px 4px 4px 2px;
  border-radius: 6px;
}
</style>
